import { render, staticRenderFns } from "./ManageAllMedia.vue?vue&type=template&id=885a9060&"
import script from "./ManageAllMedia.vue?vue&type=script&lang=js&"
export * from "./ManageAllMedia.vue?vue&type=script&lang=js&"
import style0 from "./ManageAllMedia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports